import _get from 'lodash/get'
import _reduce from 'lodash/reduce'
import { Map, fromJS } from 'immutable'
import { getNodeList, getNode } from '../../node'
import {
  setPmNodesProcessing,
  setPmNodeProcessing,
  setPmNode,
  setPmNodes,
  setPmNodesError,
  GET_PM_NODE,
  GET_PM_NODES,
} from './actions'

const log = console

async function getPmNodeHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const nid = payload

  try {
    store.dispatch(setPmNodeProcessing(nid))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      nid,
    }

    const node = await getNode(options)
    const id = node.get('nid').toString()
    store.dispatch(setPmNode({
      data: node,
      id,
    }))
  } catch (error) {
    log.error(error, 'Error updating section')
    store.dispatch(setPmNodesError({
      error,
    }))
  }
}

async function getPmNodesHandler ({ store, payload }) {
  const { config, auth } = store.getState()
  const lists = payload
  const listItems = _reduce(lists, (acc, list) => {
    acc.push(_get(list, 'listItems'))
    return acc
  }, [])
  const merged = [].concat.apply([], listItems) // eslint-disable-line prefer-spread
  let nids = merged.map((list) => parseInt(_get(list, 'id'), 10))
  // remove NaN
  nids = nids.filter(Boolean)

  if (!nids || !nids.length) {
    return
  }

  try {
    store.dispatch(setPmNodesProcessing({}))
    const nodeList = await getNodeList({
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      nids: fromJS(nids),
    })
    store.dispatch(setPmNodes({
      data: nodeList.reduce((acc, node) => acc.set(node.get('nid'), node), Map()),
    }))
  } catch (error) {
    log.error(error, 'Error updating section')
    store.dispatch(setPmNodesError({
      error,
    }))
  }
}

export default (store) => (next) => (action) => {
  const { type, payload } = action
  switch (type) {
    case GET_PM_NODE:
      getPmNodeHandler({ store, payload })
      break
    case GET_PM_NODES:
      getPmNodesHandler({ store, payload })
      break
    default:
      break
  }
  next(action)
}
